export const cssClass = (className: string) => {
  return { $$css: true, _: `app-${className}` };
};
